import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { DataRowTitle } from "app/pages/keyword-research/keyword-analysis/pages/keywords-overview/components/datarow/DataRowStyledComponents";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { MetricContainer } from "../../StyledComponent";

const { carbon } = colorsPalettes;

export const TrafficMetricContainerStyled = styled(FlexColumn)<{ isLoading: boolean }>`
    min-width: 284px;
    padding: 24px;
    &:first-child {
        border-right: 1px solid ${carbon[50]};
    }
    ${DataRowTitle} {
        padding-bottom: ${({ isLoading }) => (isLoading ? "8px" : "54px")};
        margin-bottom: 0;
    }
    .non-selectable-legends-wrapper {
        gap: 16px;
    }
`;
export const TrafficDistributionWrapper = styled(MetricContainer)`
    display: flex;
    flex-direction: row;
    padding: 0;
`;

const LoadingSpinner = styled(Spinner)<{ top?: string }>`
    margin: 0 auto;
    position: relative;
    top: ${({ top }) => top ?? "40px"};
    width: 55px;
    height: 55px;
`;

export const LegendComponentWrapper = styled.div`
    width: 145px;
`;

export const LegendValuesWrapper = styled(FlexRow)`
    justify-content: space-between;
    padding-right: 24px;
    align-items: flex-end;
`;
export const LegendValuesShare = styled.div`
    padding-right: 12px;
`;
